import React from 'react';

import {Head} from 'coreUtils/adapters/head';

import {ICanonicalProps} from '../ISeoProps';

const Canonical = ({href}: ICanonicalProps) => {
	return (
		<Head>
			<link key={href} rel="canonical" href={decodeURI(href)} as="document" />
		</Head>
	);
};

export default Canonical;
